import React, { useState, useEffect, useReducer, useRef } from "react";
import * as utils from "../../../common/utils";
import WBTools from "./toolbar/Toolbar";
import _ from "lodash";
import { Toast } from "devextreme-react/toast";
import * as actions from "../../../actions/siteDetails";
import siteReducer from "../../../reducers/siteDetails";
//import { SketchField, Tools } from "react-sketch";
const initialState = { wbData: null };
export default (props) => {
  const { siteId, widgetId, isRps, wbRef, rpsData } = props;
  const [state, dispatch] = useReducer(siteReducer, initialState);
  const { wbData } = state;
  useEffect(() => {
    if (!isRps) actions.getWBData(dispatch, `${siteId}&widgetId=${widgetId}`);
  }, []);
  let sketchRef = useRef(null);
  const [toolTxt, setTools] = useState("Pencil");
  const [penClr, setClrs] = useState("#000000");
  const [paintVal, setPaintVal] = useState(null);
  const [linVal, setLinVal] = useState(2);
  const updateTool = (val) => {
    setPaintVal(sketchRef.toJSON());
    setTools(val);
  };
  const addTxt = () => sketchRef.addText("Text");
  const clearItem = () => {
    sketchRef.removeSelected();
  };
  const [lnClr, setLnClr] = useState("#000000");
  const [bgClr, setBgClr] = useState(null);
  const [fillClr, setFillClr] = useState(null);
  const wbKey = "wbData_" + widgetId;
  useEffect(() => {
    let wbData = { objects: [] };
    utils.set(wbKey, wbData);
    setPaintVal(wbData);
    sketchRef.value = wbData;
    if (!isRps) actions.getWBData(dispatch, `${siteId}&widgetId=${widgetId}`);
  }, [widgetId]);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "info",
    message: "",
  });
  useEffect(() => {
    if (isRps)
      dispatch({
        type: "FETCH_WB_INFO",
        payload: rpsData ? rpsData : { objects: [] },
      });
  }, [rpsData]);
  function onHiding() {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  }

  const saveWbInfo = (val) => {
    if (!isRps) {
      let data = {
        data: val,
        SiteId: siteId,
        widgetId: widgetId,
      };
      actions.updateWBData(dispatch, data);
    }
  };

  const updateProps = (k, val) => {
    switch (k) {
      case "width":
        setPaintVal(sketchRef.toJSON());
        setLinVal(val.value);
        break;
      case "clear":
        sketchRef.removeSelected();
        break;
      case "zIn":
        sketchRef.zoom(1.5);
        break;
      case "zOut":
        sketchRef.zoom(0.8);
        break;
      case "undo":
        sketchRef.undo();
        setPaintVal(sketchRef.toJSON());
        utils.set(wbKey, sketchRef.toJSON());
        break;
      case "redo":
        sketchRef.redo();
        break;
      case "remove":
        sketchRef.clear();
        setPaintVal(sketchRef.toJSON());
        utils.set(wbKey, sketchRef.toJSON());
        break;
    }
  };

  useEffect(() => {
    if (wbData) {
      utils.set(wbKey, wbData);
      setPaintVal(wbData);
      sketchRef.value = wbData;
    } else {
      let wbData = { objects: [] };
      utils.set(wbKey, wbData);
      setPaintVal(wbData);
      sketchRef.value = wbData;
    }
  }, [wbData]);
  useEffect(() => {
    if (isRps) {
      wbRef(wbKey);
    }
    return () => {
      saveWbInfo(utils.get(wbKey));
    };
  }, []);

  const saveWbData = () => {
    let data = {
      data: sketchRef.toJSON(),
      SiteId: siteId,
      widgetId: widgetId,
    };
    actions.updateWBData(dispatch, data);
    setPaintVal(sketchRef.toJSON());
    setToastConfig({
      ...toastConfig,
      isVisible: true,
      type: "success",
      message: "Whiteboard Saved!",
    });
  };

  const updateBg = (e) => setBgClr(e.value);

  const updateClrs = (k, v) => {
    setPaintVal(sketchRef.toJSON());
    switch (k) {
      case "fill":
        setFillClr(v);
        break;
      case "line":
        setClrs(v);
        break;
      case "bg":
        setBgClr(v);
        break;
    }
  };

  const changeHndlr = () => {
    if (sketchRef && !_.isEqual(paintVal, sketchRef.toJSON())) {
      let data = sketchRef.toJSON();
      if (data["objects"].length === 0) {
        if (
          paintVal &&
          paintVal["objects"] !== undefined &&
          paintVal["objects"].length > 0
        ) {
          utils.set(wbKey, paintVal);
        }
      } else utils.set(wbKey, data);
    }
  };

  return (
    <div className="wb-container">
      <WBTools
        updateTool={updateTool}
        updateProps={updateProps}
        save={saveWbData}
        updateBg={updateBg}
        bgColor={bgClr}
        addTxt={addTxt}
        clear={clearItem}
        setLnClr={(e) => {
          setClrs(e.value);
        }}
        lnClr={penClr}
        updateClrs={updateClrs}
        fillColor={fillClr}
        isRps={isRps}
      />
      <div style={{ background: "#fff" }}>
        {/* <SketchField
          defaultValue={paintVal}
          tool={Tools[toolTxt]}
          lineColor={penClr}
          lineWidth={linVal}
          fillWithColor={true}
          fillColor={fillClr ? fillClr : "transparent"}
          value={paintVal}
          ref={(c) => (sketchRef = c)}
          forceValue={true}
          onChange={changeHndlr}
        /> */}
      </div>
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={2000}
      />
    </div>
  );
};
